import styled from 'styled-components'
import { colors, breakpoints } from '../../css-variables'

export default styled.div`
    @media screen and ${breakpoints.laptopSMax} {
        display: inline-block;
        margin-left: 12px;
        width: 32px;
        span {
            display: inline-block;
            background-color: ${colors.buttonRed};
            height: 2px;
            transition: all 0.3s linear;
            position: relative;
            width: 32px;
            top: -6px;
        }
        span::before {
            width: 32px;
            height: 2px;
            background-color: ${colors.buttonRed};
            content: '';
            position: absolute;
            -webkit-transition: all 0.3s linear;
            transition: all 0.3s linear;
            top: -7px;
            left: 0;
        }
        span::after {
            width: 32px;
            height: 2px;
            background-color: ${colors.buttonRed};
            content: '';
            position: absolute;
            -webkit-transition: all 0.3s linear;
            transition: all 0.3s linear;
            bottom: -7px;
            left: 0;
        }

        &.open span {
            width: 20px;
            height: 20px;
            border: 1px solid #c5050c;
            border-radius: 50%;
            background-color: white;
            top: 4px;
        }

        &.open span::before {
            background-color: #c5050c;
            -webkit-transform: rotate(-45deg) translate(-8.5px, 13px);
            -ms-transform: rotate(-45deg) translate(-8.5px, 13px);
            transform: rotate(-45deg) translate(-8.5px, 13px);
            width: 12px;
        }

        &.open span::after {
            -webkit-transform: rotate(45deg) translate(-8px, -13px);
            -ms-transform: rotate(45deg) translate(-8px, -13px);
            transform: rotate(45deg) translate(-8px, -13px);
            width: 12px;
        }
    }
`
